// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static empresas:string="empresas";
    public static departamentos:string="departamentos";
    public static empresaslista:string="empresaslista";
    public static departamentoslista:string="departamentoslista";
    public static cerrar_session:string="cerrar_session";
    public static notificaciones:string="notificaciones";
    public static table:string="table";
    public static tablas:string="tablas";
    public static tablas_test:string="tablas_test";
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static usuariosformulario:string="usuariosformulario";
    public static mi_perfil:string="mi_perfil";
    public static administracion:string="administracion";
    public static gruposlista:string="gruposlista";
    public static grupos:string="grupos";
    public static gruposformulario:string="gruposformulario";
    public static lostpwd:string="lostpwd";
    public static confirm_new_password:string="confirm_new_password";
    public static instalacion:string="instalacion";
    public static tipos_contratoFormulario:string="tipos_contratoFormulario";
    public static tipos_contrato:string="tipos_contrato";
    public static rol:string="rol";
    public static rollista:string="rollista";
    public static rolformulario:string="rolformulario";
    public static plataforma:string="plataforma";
    public static instalacion_plataforma:string="instalacion_plataforma";
    public static tablasformulario:string="tablasformulario";
    public static tablaslista:string="tablaslista";
    public static menu_plataforma:string="menu_plataforma";
    public static menu_plataforma_lista:string="menu_plataforma_lista";
    public static menu_plataforma_formulario:string="menu_plataforma_formulario";
    public static empresasformulario:string="empresasformulario";
    public static departamentosformulario:string="departamentosformulario";
    public static centros_de_trabajo:string="centros_de_trabajo";
    public static centros_de_trabajoformulario:string="centros_de_trabajoformulario";
    public static planes:string="planes";
    public static planesformulario:string="planesformulario";
    public static conveniosformulario:string="conveniosFormulario";
    public static convenios:string="convenios";
    public static datos_empresa:string="datos_empresa";
    public static datos_empresaformulario:string="datos_empresaformulario";
    public static datos_empresaformulario_empresa:string="datos_empresaformulario_empresa";
    public static enumeraciones:string="enumeraciones";
    public static enumeracion:string="enumeracion";
    public static objetivos:string="objetivos";
    public static objetivosformulario:string="objetivosformulario";
    public static actuaciones:string="actuaciones";
    public static actuacionesFormulario:string="actuacionesFormulario";
    public static tareas:string="tareas";
    public static tareasFormulario:string="TareasFormulario";
    public static viewKanban:string="viewKanban";
    public static kanban:string="kanban";
    public static tbkn:string="tbkn";
    public static viewtbkn:string="viewtbkn";
    public static contratos_empleado:string="contratos_empleado";
    public static fichaje:string="fichaje";
    public static fichajeform:string="fichajeform";
    public static tipos_fichaje:string="tipos_fichaje";
    public static TiposFichajeFormulario:string="TiposFichajeFormulario";
    public static fichajes:string="fichajes";
    public static FichaFichajeFormulario:string="FichaFichajeFormulario";
    public static listafichajes:string="listafichajes";
    public static dxtable:string="dxtable";
    public static informes:string="informes";
    public static informe1:string="informe1";
    public static informe2:string="informe2";
    public static informe3:string="informe3";
    public static clientesformulario:string="clientesformulario";
    public static clientes:string="clientes";
    public static usuariosfichajes:string="usuariosfichajes";
    public static usuarios_plataforma_admin:string="usuarios_plataforma_admin";
    public static admin:string="admin";
    public static logs:string="logs";
    public static logsformulario:string="logsformulario";
    public static fichajes_gps:string="fichajes_gps";
    public static calendario:string="calendario";
    public static calendariolaboral:string="calendariolaboral";
    public static testcomponent:string="testcomponent";
    public static otp:string="otp";
    public static main:string="main";
    public static configurarotp:string="configurarotp";
    public static logearotp:string="logearotp";
    public static permisos:string="permisos";
    public static permisoslista:string="permisoslista";
    public static calendario_fichajes:string="calendario_fichajes";
    public static edicion_masiva_fichajes:string="edicion_masiva_fichajes";
    public static chat:string="chat";
    public static chatmain:string="chatmain";
    public static configchatmain:string="configchatmain";
    public static chatid:string="chatid";
    public static marketplace:string="marketplace";
    public static workflows:string="workflows";
    public static workflows_id:string="workflows_id";
    public static chat_workflow:string="chat_workflow";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";   
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";   
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";   

}
